import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default class DropdownRow extends Component {
    static propTypes = {
        handleDropdownRowClick: PropTypes.func.isRequired,
        locked: PropTypes.bool,
        statementType: PropTypes.string,
        text: PropTypes.string.isRequired,
    }

    static defaultProps = {
        locked: false,
    }

    render() {
        const { text, locked, handleDropdownRowClick, statementType } = this.props

        return (
            <div
                className={cx('dropdown-row', locked && 'locked')}
                onClick={() => handleDropdownRowClick(statementType)}
            >
                {text}
            </div>
        )
    }
}
